import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

interface IRatioVoteProps {
    data: {
        allow: number;
        disallow: number;
    }
}

interface IAllowProps {
    width: number;
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media only screen and (min-width : 768px) {
        min-width: 200px;
    }
`;

const RatioInfo = styled.div`
    font-size: 12px;
    line-height: 20px;
    display: flex;
    justify-content: space-between;
    min-width: 100px;
    @media only screen and (min-width : 768px) {
        font-size: 14px;
        min-width: 200px;
    }
`;

const RatioLabel = styled.span`
    font-weight: 500;
    color: #363870;
    margin-right: 4px;
`;

const RatioPercent = styled.span`
    font-weight: 400;
    color: #8082C5;
`;

const RatioProgress = styled.div`
    display: flex;
    width: 100%;
    height: 8px;
`;

const RatioAllow = styled.div<IAllowProps>`
    background: #7075E9;
    border-radius: 4px;
    width: ${({width}) => width + '%'};
    transition: width 1s ease-in-out;
`;

const RatioDisallow = styled.div<IAllowProps>`
    background: #EE505A;
    border-radius: 4px;
    width: ${({width}) => width + '%'};
    transition: width 1s ease-in-out;
`;

export default observer(function(props: IRatioVoteProps) {
    return (
        <Root>
            <RatioInfo>
                <div>
                    <RatioLabel>Yes</RatioLabel>
                    <RatioPercent>{props.data.allow.toFixed(0)}%</RatioPercent>
                </div>
                <div>
                    <RatioLabel>No</RatioLabel>
                    <RatioPercent>{props.data.disallow.toFixed(0)}%</RatioPercent>
                </div>
            </RatioInfo>
            <RatioProgress>
                <RatioAllow width={props.data.allow}/>
                <RatioDisallow width={props.data.disallow}/>
            </RatioProgress>
        </Root>
    );
});